import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "client-filter-modal" }
const _hoisted_2 = { class: "client-filter-modal__search" }
const _hoisted_3 = { class: "client-filter-modal__body-item" }
const _hoisted_4 = { class: "client-filter-modal__body-item" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  class: "client-filter-modal__body-item-holding"
}
const _hoisted_7 = ["onClick"]

import {
	computed,
	nextTick,
	onMounted,
	ref
} from "vue";
import AppCheckbox from "@/components/ui-kit/checkbox/AppCheckbox.vue";
import AppInput from "@/components/ui-kit/input/AppInput.vue";
import AppLoader from "@/components/common/AppLoader.vue";
import {
	searchStore,
	ClientFilterOption,
	ClientFilterUnion
} from "@/store/search";


export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectClientFilterDropdown',
  emits: ['change'],
  setup(__props, { emit: __emit }) {

const emit = __emit

const $input = ref<typeof AppInput | null>(null)
const $body = ref<HTMLDivElement | null>(null)

const store = searchStore()

const filter = ref('')

const isLoading = computed(() => store.isClientFilterLoading)

// Подсветка чекбокса по паре (Id, UseUnion): верхнеуровневый «с холдингом» (true) и
// вложенный (false) могут иметь одинаковый Id, но выбран может быть только один из них.
const isChecked = (id: number, useUnion: boolean) =>
	store.selectedClients.some(c => c.Id === id && c.UseUnion === useUnion)

const filteredOptions = computed<ClientFilterOption[]>(() => {
	const query = filter.value.trim().toLowerCase()
	if (!query) {
		return store.clientFilterList
	}

	return store.clientFilterList.filter(opt =>
		opt.Name?.toLowerCase().includes(query)
		|| opt.Union.some(m => m.Name?.toLowerCase().includes(query))
	)
})

const loaderStyle = computed(() => ({
	'background-color': 'rgba(255, 255, 255, 0.5)'
}))

const onToggleByBase = (on: boolean) => {
	store.setByBase(on)
	emit('change')
}

const onToggleClient = (opt: ClientFilterOption, on: boolean) => {
	store.toggleSelectedClient({ Id: opt.Id, Name: opt.Name, UseUnion: true }, on)
	emit('change')
}

const onToggleUnion = (member: ClientFilterUnion, on: boolean) => {
	store.toggleSelectedClient({ Id: member.Id, Name: member.Name, UseUnion: false }, on)
	emit('change')
}

onMounted(async () => {
	await nextTick(() => $input.value?.focusInput())
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isLoading.value)
      ? (_openBlock(), _createBlock(AppLoader, {
          key: 0,
          style: _normalizeStyle(loaderStyle.value)
        }, null, 8, ["style"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(AppInput, {
        ref_key: "$input",
        ref: $input,
        modelValue: filter.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filter).value = $event)),
        class: "client-filter-modal__search-input",
        placeholder: "Поиск",
        "show-search-button": ""
      }, null, 8, ["modelValue"])
    ]),
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "client-filter-modal__header" }, [
      _createElementVNode("div", { class: "client-filter-modal__header-title" }, " Клиенты ")
    ], -1)),
    _createElementVNode("div", {
      class: "client-filter-modal__body",
      ref_key: "$body",
      ref: $body
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(AppCheckbox, {
          style: { height: '16px', marginRight: '8px' },
          value: _unref(store).byBase,
          text: "",
          onInput: onToggleByBase
        }, null, 8, ["value"]),
        _createElementVNode("div", {
          class: "client-filter-modal__body-item-text",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (onToggleByBase(!_unref(store).byBase)))
        }, " По базе ")
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredOptions.value, (opt) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: opt.Id
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(AppCheckbox, {
              style: { height: '16px', marginRight: '8px' },
              value: isChecked(opt.Id, true),
              text: "",
              onInput: (on) => onToggleClient(opt, on)
            }, null, 8, ["value", "onInput"]),
            _createElementVNode("div", {
              class: "client-filter-modal__body-item-text",
              onClick: ($event: any) => (onToggleClient(opt, !isChecked(opt.Id, true)))
            }, [
              _createTextVNode(_toDisplayString(opt.Name), 1),
              (opt.Union.length)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, " (с холдингом)"))
                : _createCommentVNode("", true)
            ], 8, _hoisted_5)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(opt.Union, (member) => {
            return (_openBlock(), _createElementBlock("div", {
              key: member.Id,
              class: "client-filter-modal__body-item client-filter-modal__body-item--union"
            }, [
              _createVNode(AppCheckbox, {
                style: { height: '16px', marginRight: '8px' },
                value: isChecked(member.Id, false),
                text: "",
                onInput: (on) => onToggleUnion(member, on)
              }, null, 8, ["value", "onInput"]),
              _createElementVNode("div", {
                class: "client-filter-modal__body-item-text",
                onClick: ($event: any) => (onToggleUnion(member, !isChecked(member.Id, false)))
              }, _toDisplayString(member.Name), 9, _hoisted_7)
            ]))
          }), 128))
        ], 64))
      }), 128))
    ], 512)
  ]))
}
}

})